/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'editor-common-extensibility-extension-lozenge-editToggle.done.editing': 'Закончить редактирование',
  'editor-common-extensibility-extension-lozenge-editToggle.make.edits': 'Внести правки',
  'editor-common-extensibility.macro.button.configure': 'Настроить макрос «{macroName}»',
  'fablric.editor.viewAllInserts': 'Просмотреть все вставляемые элементы',
  'fabric.editor.action': 'Задача',
  'fabric.editor.action.description': 'Создавайте и назначайте задачи',
  'fabric.editor.addAltText': 'Альтернативный текст',
  'fabric.editor.addColumnLeft': 'Добавить столбец слева',
  'fabric.editor.addColumnRight': 'Добавить столбец справа',
  'fabric.editor.addCommentOnMedia': 'Добавить комментарий',
  'fabric.editor.addImageBorder': 'Добавить рамку',
  'fabric.editor.addLoomVideo': 'Записать видео Loom',
  'fabric.editor.addLoomVideoComment': 'Записать видеокомментарий Loom',
  'fabric.editor.addMediaFiles': 'Добавить изображение, видео или файл',
  'fabric.editor.addRowAbove': 'Добавить строку выше',
  'fabric.editor.addRowBelow': 'Добавить строку ниже',
  'fabric.editor.addUpdatedAltText': 'Добавить альтернативный текст',
  'fabric.editor.ai.ai-panels.actionItemsPageDescription':
    'Используйте Atlassian Intelligence, чтобы найти список задач и отобразить его на панели',
  'fabric.editor.ai.ai-panels.actionItemsPageTitle': 'Панель списка задач (бета-версия)',
  'fabric.editor.ai.ai-panels.summarizePageDescription':
    'Используйте Atlassian Intelligence, чтобы создать краткое описание страницы и отобразить его на панели',
  'fabric.editor.ai.ai-panels.summarizePageTitle': 'Панель краткого описания страницы (бета-версия)',
  'fabric.editor.ai.ai-smart-button.context.reference': 'Выбранный контент',
  'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription':
    'Генерирует контент для вставки в обновление',
  'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': 'Создает сводку контента в обновлении',
  'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': 'Сгенерировать',
  'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': 'Задать вопрос Atlassian Intelligence',
  'fabric.editor.ai.config.item.action.edit': 'Изменить',
  'fabric.editor.ai.config.item.action.insert': 'Вставить',
  'fabric.editor.ai.config.item.action.insertAtTop': 'Вставить сверху',
  'fabric.editor.ai.config.item.action.insertBelow': 'Вставить снизу',
  'fabric.editor.ai.config.item.action.replace': 'Заменить',
  'fabric.editor.ai.config.item.action.replaceTitle': 'Заменить заголовок',
  'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip':
    'Максимальное количество символов в заголовке — {maxLength}',
  'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': 'Открыть в чате',
  'fabric.editor.ai.config.item.agent.title': 'Агент Rovo на базе Atlassian Intelligence',
  'fabric.editor.ai.config.item.atlas-shorten-update.description': 'Сокращает контент, чтобы сделать его более емким.',
  'fabric.editor.ai.config.item.atlas-shorten-update.title': 'Сокращение контента в обновлении',
  'fabric.editor.ai.config.item.bb.pr.description.description': 'Создает описание запроса pull со сводкой изменений.',
  'fabric.editor.ai.config.item.bb.pr.description.title': 'Создать описание запроса pull',
  'fabric.editor.ai.config.item.brainstorm.description': 'Генерирует список идей на заданную тему.',
  'fabric.editor.ai.config.item.brainstorm.promptHint': 'Задайте тему…',
  'fabric.editor.ai.config.item.brainstorm.promptLabel': 'Мозговой штурм',
  'fabric.editor.ai.config.item.brainstorm.title': 'Мозговой штурм',
  'fabric.editor.ai.config.item.changeTone.casualTone.description': 'Изменяет стиль контента на непринужденный.',
  'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Непринужденный',
  'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'Непринужденный',
  'fabric.editor.ai.config.item.changeTone.casualTone.title': 'Изменить стиль на непринужденный',
  'fabric.editor.ai.config.item.changeTone.educationalTone.description': 'Изменяет стиль контента на обучающий.',
  'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': 'Обучающий',
  'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': 'Обучающий',
  'fabric.editor.ai.config.item.changeTone.educationalTone.title': 'Изменить стиль на обучающий',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.description': 'Изменяет стиль контента на сочувственный.',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Сочувственный',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': 'Сочувственный',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.title': 'Изменить стиль на сочувственный',
  'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': 'Изменить стиль на…',
  'fabric.editor.ai.config.item.changeTone.neutralTone.description': 'Изменяет стиль контента на нейтральный.',
  'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Нейтральный',
  'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': 'Нейтральный',
  'fabric.editor.ai.config.item.changeTone.neutralTone.title': 'Изменить стиль на нейтральный',
  'fabric.editor.ai.config.item.changeTone.professionalTone.description':
    'Изменяет стиль контента на профессиональный.',
  'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Профессиональный',
  'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': 'Профессиональный',
  'fabric.editor.ai.config.item.changeTone.professionalTone.title': 'Изменить стиль на профессиональный',
  'fabric.editor.ai.config.item.convertToBulletList.description': 'Изменение формата контента на маркированный список',
  'fabric.editor.ai.config.item.convertToBulletList.title': 'Преобразовать в маркированный список',
  'fabric.editor.ai.config.item.convertToTable.description': 'Изменить формат контента на таблицу с заголовками',
  'fabric.editor.ai.config.item.convertToTable.title': 'Преобразовать в таблицу',
  'fabric.editor.ai.config.item.draftReply.description':
    'Составляет ответ на основе задач, похожих на ту, над которой вы работаете.',
  'fabric.editor.ai.config.item.draftReply.title': 'Составить ответ',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description':
    'Исправляет орфографические и грамматические ошибки.',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title':
    'Орфография и грамматика',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': 'Исправить орфографию и грамматику',
  'fabric.editor.ai.config.item.enhance.improveWriting.description':
    'Улучшает четкость, структуру и стиль текста, чтобы сделать его более интересным и понятным.',
  'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': 'Улучшить текст',
  'fabric.editor.ai.config.item.enhance.improveWriting.title': 'Улучшить текст',
  'fabric.editor.ai.config.item.findActionItems.description': 'Находит список задач в указанном контенте.',
  'fabric.editor.ai.config.item.findActionItems.title': 'Найти список задач',
  'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint':
    'Выберите из списка ниже (свободная генерация в Elevate в настоящее время отключена).',
  'fabric.editor.ai.config.item.generateContent.promptHint': 'Пишите вместе с AI или выберите пункт из списка ниже.',
  'fabric.editor.ai.config.item.improveDescription.default.description':
    'Изменяет структуру описания задачи в зависимости от ее типа.',
  'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': 'Улучшить описание',
  'fabric.editor.ai.config.item.makeLonger.description': 'Дополнить контент на основе предоставленного контекста',
  'fabric.editor.ai.config.item.makeLonger.title': 'Сделать длиннее',
  'fabric.editor.ai.config.item.range.agent.description': 'Без описания',
  'fabric.editor.ai.config.item.range.agent.prompt.hint':
    'Попросите агента написать что-нибудь или выберите из списка ниже',
  'fabric.editor.ai.config.item.rephrase.description': 'Создать рекомендации по перефразированию предложений',
  'fabric.editor.ai.config.item.rephrase.title': 'Перефразировать',
  'fabric.editor.ai.config.item.shorten.description': 'Сокращает контент, чтобы сделать его более емким.',
  'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': 'Сократить',
  'fabric.editor.ai.config.item.shorten.title': 'Сократить',
  'fabric.editor.ai.config.item.suggest.description': 'Предлагает заголовок для указанного контента.',
  'fabric.editor.ai.config.item.suggest.title': 'Предложить название',
  'fabric.editor.ai.config.item.summarize.description':
    'Резюмирует текст, над которым вы работаете, чтобы подчеркнуть ключевые моменты.',
  'fabric.editor.ai.config.item.summarize.dropdownItem.title': 'Резюмировать текст',
  'fabric.editor.ai.config.item.summarize.title': 'Резюмировать текст',
  'fabric.editor.ai.config.item.translate.czech': 'Чешский',
  'fabric.editor.ai.config.item.translate.danish': 'Датский',
  'fabric.editor.ai.config.item.translate.dutch': 'Датский',
  'fabric.editor.ai.config.item.translate.english': 'Английский',
  'fabric.editor.ai.config.item.translate.finnish': 'Финский',
  'fabric.editor.ai.config.item.translate.french': 'Французский',
  'fabric.editor.ai.config.item.translate.german': 'Немецкий',
  'fabric.editor.ai.config.item.translate.hungarian': 'Венгерский',
  'fabric.editor.ai.config.item.translate.italian': 'Итальянский',
  'fabric.editor.ai.config.item.translate.japanese': 'Японский',
  'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': 'Перевести',
  'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': 'Перевести на…',
  'fabric.editor.ai.config.item.translate.norwegian': 'Норвежский',
  'fabric.editor.ai.config.item.translate.russian': 'Русский',
  'fabric.editor.ai.config.item.translate.spanish': 'Испанский',
  'fabric.editor.ai.config.item.translate.swedish': 'Шведский',
  'fabric.editor.ai.config.item.translate.thai': 'Тайский',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.description':
    'Перевод текста, над которым вы работаете, на китайский язык (упрощенный вариант)',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': 'Перевести на китайский (упрощенный)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.description':
    'Перевод текста, над которым вы работаете, на китайский язык (традиционный)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': 'Перевести на китайский (традиционный)',
  'fabric.editor.ai.config.item.translateTo.czech.description':
    'Перевод текста, над которым вы работаете, на чешский язык',
  'fabric.editor.ai.config.item.translateTo.czech.title': 'Перевести на чешский',
  'fabric.editor.ai.config.item.translateTo.danish.description':
    'Перевод текста, над которым вы работаете, на датский язык',
  'fabric.editor.ai.config.item.translateTo.danish.title': 'Перевести на датский',
  'fabric.editor.ai.config.item.translateTo.dutch.description':
    'Перевод текста, над которым вы работаете, на голландский язык',
  'fabric.editor.ai.config.item.translateTo.dutch.title': 'Перевести на голландский',
  'fabric.editor.ai.config.item.translateTo.english.description':
    'Перевод текста, над которым вы работаете, на английский язык',
  'fabric.editor.ai.config.item.translateTo.english.title': 'Перевести на английский',
  'fabric.editor.ai.config.item.translateTo.finnish.description':
    'Перевод текста, над которым вы работаете, на финский язык',
  'fabric.editor.ai.config.item.translateTo.finnish.title': 'Перевести на финский',
  'fabric.editor.ai.config.item.translateTo.french.description':
    'Перевод текста, над которым вы работаете, на французский язык',
  'fabric.editor.ai.config.item.translateTo.french.title': 'Перевести на французский',
  'fabric.editor.ai.config.item.translateTo.german.description':
    'Перевод текста, над которым вы работаете, на немецкий язык',
  'fabric.editor.ai.config.item.translateTo.german.title': 'Перевести на немецкий',
  'fabric.editor.ai.config.item.translateTo.hungarian.description':
    'Перевод текста, над которым вы работаете, на венгерский язык',
  'fabric.editor.ai.config.item.translateTo.hungarian.title': 'Перевести на венгерский',
  'fabric.editor.ai.config.item.translateTo.italian.description':
    'Перевод текста, над которым вы работаете, на итальянский язык',
  'fabric.editor.ai.config.item.translateTo.italian.title': 'Перевести на итальянский',
  'fabric.editor.ai.config.item.translateTo.japanese.description':
    'Перевод текста, над которым вы работаете, на японский язык',
  'fabric.editor.ai.config.item.translateTo.japanese.title': 'Перевести на японский',
  'fabric.editor.ai.config.item.translateTo.korean.description':
    'Перевод текста, над которым вы работаете, на корейский язык',
  'fabric.editor.ai.config.item.translateTo.korean.title': 'Перевести на корейский',
  'fabric.editor.ai.config.item.translateTo.norwegian.description':
    'Перевод текста, над которым вы работаете, на норвежский язык',
  'fabric.editor.ai.config.item.translateTo.norwegian.title': 'Перевести на норвежский',
  'fabric.editor.ai.config.item.translateTo.polish.description':
    'Перевод текста, над которым вы работаете, на польский язык',
  'fabric.editor.ai.config.item.translateTo.polish.title': 'Перевести на польский',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description':
    'Перевод текста, над которым вы работаете, на португальский язык (бразильский вариант)',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': 'Перевести на португальский (бразильский)',
  'fabric.editor.ai.config.item.translateTo.russian.description':
    'Перевод текста, над которым вы работаете, на русский язык',
  'fabric.editor.ai.config.item.translateTo.russian.title': 'Перевести на русский',
  'fabric.editor.ai.config.item.translateTo.spanish.description':
    'Перевод текста, над которым вы работаете, на испанский язык',
  'fabric.editor.ai.config.item.translateTo.spanish.title': 'Перевод на испанский',
  'fabric.editor.ai.config.item.translateTo.swedish.description':
    'Перевод текста, над которым вы работаете, на шведский язык',
  'fabric.editor.ai.config.item.translateTo.swedish.title': 'Перевести на шведский',
  'fabric.editor.ai.config.item.translateTo.thai.description':
    'Перевод текста, над которым вы работаете, на тайский язык',
  'fabric.editor.ai.config.item.translateTo.thai.title': 'Перевести на тайский',
  'fabric.editor.ai.config.item.translateTo.turkish.description':
    'Перевод текста, над которым вы работаете, на турецкий язык',
  'fabric.editor.ai.config.item.translateTo.turkish.title': 'Перевести на турецкий',
  'fabric.editor.ai.config.item.translateTo.ukrainian.description':
    'Перевод текста, над которым вы работаете, на украинский язык',
  'fabric.editor.ai.config.item.translateTo.ukrainian.title': 'Перевести на украинский',
  'fabric.editor.ai.config.item.translateTo.vietnamese.description':
    'Перевод текста, над которым вы работаете, на вьетнамский язык',
  'fabric.editor.ai.config.item.translateTo.vietnamese.title': 'Перевести на вьетнамский',
  'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'Изменить стиль',
  'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Переписать',
  'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': 'Перевести',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'Заголовок страницы',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'Страница',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Не удается вставить ответ. Закройте диалоговое окно и повторите попытку.',
  'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage':
    'Не удается создать изображение для предварительного просмотра. Закройте диалоговое окно и повторите попытку.',
  'fabric.editor.ai.experience-application.rateLimitEnforced':
    'В последнее время получено слишком много запросов на Atlassian Intelligence (AI). Повторите попытку через несколько минут или узнайте больше о <link>чрезмерном использовании AI</link>.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Не удалось получить ответ. Ваш запрос или ответ превысили ограничение для данного запроса. Закройте окно и повторите попытку.',
  'fabric.editor.ai.experience-application.unhandledErrorMessage':
    'Произошла ошибка. Закройте диалоговое окно и повторите попытку.',
  'fabric.editor.ai.experience.apiError': 'Не удалось получить ответ, повторите попытку.',
  'fabric.editor.ai.experience.aupViolationMessage':
    'Возможно, ваш запрос или контент не соответствуют нашей Политике допустимого использования. Проверьте их, а при необходимости изучите <link>Политику допустимого использования</link>. Если проблема не исчезнет, попробуйте другой запрос или контент.',
  'fabric.editor.ai.experience.browseMore.agents': 'Просмотреть агентов',
  'fabric.editor.ai.experience.discardMessagePrompt': 'Хотите сбросить запрос?',
  'fabric.editor.ai.experience.discardMessageResponse': 'Хотите сбросить ответ?',
  'fabric.editor.ai.experience.elevateDisabledGenetateError':
    'Свободная генерация в Elevate в настоящее время отключена',
  'fabric.editor.ai.experience.engagementBannerLinksText':
    '🚀 Теперь вы можете вставлять в запросы ссылки 🔗 на контент Jira и Confluence.',
  'fabric.editor.ai.experience.footerRightText.agents': 'На базе Rovo',
  'fabric.editor.ai.experience.hipaaContentError':
    'Atlassian Intelligence не удалось обработать запрос, так как в контенте содержатся ссылки на содержимое, доступ к которому ограничен в соответствии с требованиями HIPAA. Удалите эти ссылки и повторите попытку.',
  'fabric.editor.ai.experience.inputTooShortError':
    'Контент слишком короткий для создания сводки. Добавьте информацию и повторите попытку.',
  'fabric.editor.ai.experience.internalServerError':
    'Atlassian Intelligence (AI) не отвечает. Повторите попытку позже или <link>проверьте статус AI</link>.',
  'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
  'fabric.editor.ai.experience.loadingTitle': 'Выполняется генерация',
  'fabric.editor.ai.experience.messageTemplateAnalysingQuery': 'Анализ: рассмотрение вопроса.',
  'fabric.editor.ai.experience.messageTemplateContentSearch': 'Поиск: подождите немного, пока идет поиск информации.',
  'fabric.editor.ai.experience.messageTemplateNextBestTask': 'Поиск: подождите немного, пока идет поиск в Jira.',
  'fabric.editor.ai.experience.messageTemplatePageHydration': 'Поиск: подождите немного, пока идет поиск страницы.',
  'fabric.editor.ai.experience.noResultsSuggestion': 'Ничего не найдено',
  'fabric.editor.ai.experience.responseTooSimilarMessage':
    'Пока у Atlassian Intelligence нет предложений. Попробуйте использовать другой запрос или контент.',
  'fabric.editor.ai.experience.showMoreButton': 'Развернуть',
  'fabric.editor.ai.experience.suggestionGroupHeading.actions': 'Действия',
  'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Агенты',
  'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian intelligence',
  'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': 'Источник знаний',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Агенты Rovo',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Агенты Rovo ({numberOfAgents})',
  'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount': 'Используйте агента Rovo ({numberOfAgents})',
  'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': 'Использовать общие знания',
  'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': 'Использовать знания организации',
  'fabric.editor.ai.proactive.error.markdownErrorMessage':
    'Не удается создать изображение для предварительного просмотра. Закройте диалоговое окно и повторите попытку.',
  'fabric.editor.ai.proactive.error.unhandledErrorMessage':
    'Произошла ошибка. Закройте диалоговое окно и повторите попытку.',
  'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': 'Вставить ниже',
  'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': 'Заменить',
  'fabric.editor.ai.screens.preview.convoAIBeta':
    'Запросы на генерацию контента, ссылающиеся на URL-адреса, находятся в стадии бета-тестирования.',
  'fabric.editor.ai.selectionToolbar.define.disabled.tooltip': 'Выделите термин, аббревиатуру или сокращение',
  'fabric.editor.ai.selectionToolbar.define.title': 'Определить',
  'fabric.editor.ai.toolbar.askAI.title': 'Задать вопрос Atlassian Intelligence',
  'fabric.editor.ai.toolbar.improveWriting.title': 'Улучшить текст',
  'fabric.editor.ai.toolbar.improveWriting.tooltip': 'Скажите Atlassian Intelligence доработать выделенный текст',
  'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
  'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
  'fabric.editor.ai.toolbar.tryAI.title': 'Попробовать AI',
  'fabric.editor.ai.toolbar.tryAI.tooltip': 'Открыть Atlassian Intelligence',
  'fabric.editor.alignCenter': 'Выровнять по центру',
  'fabric.editor.alignImageCenter': 'Выровнять по центру',
  'fabric.editor.alignImageLeft': 'Выровнять по левому краю',
  'fabric.editor.alignImageRight': 'Выровнять по правому краю',
  'fabric.editor.alignLeft': 'Выровнять по левому краю',
  'fabric.editor.alignRight': 'Выровнять по правому краю',
  'fabric.editor.alignTableCenter': 'Выровнять по центру',
  'fabric.editor.alignTableLeft': 'Выровнять по левому краю',
  'fabric.editor.alignment': 'Выравнивание текста',
  'fabric.editor.altText': 'Альтернативный текст',
  'fabric.editor.alttext.validation': 'Удалите специальные символы в alt-тексте.',
  'fabric.editor.annotationToolbar': 'Панель инструментов для примечаний',
  'fabric.editor.backLink': 'Назад',
  'fabric.editor.backgroundColor': 'Цвет фона',
  'fabric.editor.blockCardUnavailable':
    'Встроенная ссылка находится внутри узла {node} — нельзя изменить представление',
  'fabric.editor.blockControlDelete': 'Удалить',
  'fabric.editor.blockControlDragHandleMove': 'Перетащите, чтобы переместить',
  'fabric.editor.blockControlDragHandleRearrange': 'Перетащите, чтобы изменить порядок',
  'fabric.editor.blockControlInsert': 'Вставить',
  'fabric.editor.blockControlMoveDown': 'Переместить блок вниз',
  'fabric.editor.blockControlMoveLeft': 'Переместить влево',
  'fabric.editor.blockControlMoveRight': 'Переместить вправо',
  'fabric.editor.blockControlMoveUp': 'Переместить блок вверх',
  'fabric.editor.blockControlMovedDown': 'Контент перемещен вниз',
  'fabric.editor.blockControlMovedUp': 'Контент перемещен вверх',
  'fabric.editor.blockDescription':
    'Отображение дополнительной информации о ссылке, включая краткое описание и действия',
  'fabric.editor.blockTitle': 'Карточка',
  'fabric.editor.blockquote': 'цитата',
  'fabric.editor.blockquote.description': 'Вставить цитату',
  'fabric.editor.blockquote2': 'Цитировать',
  'fabric.editor.bold': 'Полужирный',
  'fabric.editor.breakoutFullWidthLabel': 'Полная ширина',
  'fabric.editor.breakoutWideWidthLabel': 'Широкий',
  'fabric.editor.bug': 'Баг',
  'fabric.editor.canNotSortTable': '⚠️ Невозможно отсортировать таблицу с объединением ячеек',
  'fabric.editor.cancelButton': 'Отменить',
  'fabric.editor.captionPlaceholder': 'Добавьте подпись',
  'fabric.editor.captionPlaceholderWithDoubleClickPrompt':
    'Добавьте подпись (нажмите дважды для предварительного просмотра)',
  'fabric.editor.cardFloatingControls': 'Параметры карточки',
  'fabric.editor.cellBackground': 'Фон ячеек',
  'fabric.editor.cellOptions': 'Параметры ячеек',
  'fabric.editor.checkUncheckActionItem': 'Выбрать / отменить выбор задачи',
  'fabric.editor.clearAltTextEdit': 'Очистить альтернативный текст',
  'fabric.editor.clearCells':
    '{0, plural, one {Очистить содержимое ячейки} few {Очистить содержимое ячеек} many {Очистить содержимое ячеек} other {Очистить содержимое ячеек}}',
  'fabric.editor.clearFormatting': 'Очистить форматирование',
  'fabric.editor.clearLink': 'Удалить ссылку',
  'fabric.editor.clearLinkText': 'Удалить текст',
  'fabric.editor.closeAltTextEdit': 'Назад',
  'fabric.editor.closeFindReplaceDialog': 'Закрыть',
  'fabric.editor.closeHelpDialog': 'Закрыть справку',
  'fabric.editor.code': 'Код',
  'fabric.editor.code.on': '{textFormattingOff}, код вкл.',
  'fabric.editor.codeBidiWarningLabel':
    'Двунаправленные символы изменяют порядок отображения текста. Они могут использоваться для маскировки вредоносного кода.',
  'fabric.editor.codeBlockCopyButton.copiedToClipboard': 'Скопировано!',
  'fabric.editor.codeBlockCopyButton.copyToClipboard': 'Скопировать как текст',
  'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': 'Отключить перенос текста',
  'fabric.editor.codeBlockWrapButton.wrapCodeBlock': 'Включить перенос текста',
  'fabric.editor.codeblock': 'Фрагмент кода',
  'fabric.editor.codeblock.description': 'Выделение синтаксиса в коде',
  'fabric.editor.collapseNode': 'Свернуть содержимое',
  'fabric.editor.collapseTable': 'Свернуть таблицу',
  'fabric.editor.colorPicker.menuLabel': 'Меню выбора цвета',
  'fabric.editor.columnDragHandle': 'Параметры столбца',
  'fabric.editor.columnMovedLeft': 'Столбец перемещен влево на позицию {index} из {total}',
  'fabric.editor.columnMovedRight': 'Столбец перемещен вправо на позицию {index} из {total}',
  'fabric.editor.columnSelected': 'Выбран столбец {index} из {total}',
  'fabric.editor.columns': 'Макеты',
  'fabric.editor.columns.advanced.layout.description':
    '{numberOfColumns, plural, one {Вставить {numberOfColumns} равный столбец} few {Вставить {numberOfColumns} равных столбца} many {Вставить {numberOfColumns} равных столбцов} other {Вставить {numberOfColumns} равного столбца}}',
  'fabric.editor.columns.advanced.layout.single.description': 'Вставить макет с одной колонкой',
  'fabric.editor.columns.description': 'Расположение информации на странице с помощью разделов',
  'fabric.editor.columnsAreInserted':
    '{count, plural, one {Вставлен {count} столбец} few {Вставлено {count} столбца} many {Вставлено {count} столбцов} other {Вставлено {count} столбца}}',
  'fabric.editor.columnsAreRemoved':
    '{count, plural, one {Удален {count} столбец} few {Удалено {count} столбца} many {Удалено {count} столбцов} other {Удалено {count} столбца}}',
  'fabric.editor.configFailedToLoad': 'Не удалось загрузить файл.',
  'fabric.editor.configPanel.cancel': 'Отмена',
  'fabric.editor.configPanel.close': 'Закрыть',
  'fabric.editor.configPanel.customSelect.createOption': 'Создать',
  'fabric.editor.configPanel.dateRange.custom.from': 'С',
  'fabric.editor.configPanel.dateRange.custom.to': 'По',
  'fabric.editor.configPanel.dateRange.grouping.collapse': 'Свернуть',
  'fabric.editor.configPanel.dateRange.grouping.expand': 'Развернуть',
  'fabric.editor.configPanel.dateRange.option.custom': 'Другая',
  'fabric.editor.configPanel.documentation': 'Документация',
  'fabric.editor.configPanel.errorBoundary.note':
    'Мы сообщили об этом команде. Вы можете отредактировать и опубликовать эту страницу или просмотреть дополнительную информацию на консоли ошибок.',
  'fabric.editor.configPanel.errorBoundary.title': 'Произошла ошибка.',
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio':
    'Невозможно использовать isMultiple с параметром style: radio',
  'fabric.editor.configPanel.formType.addField': 'Добавить поле',
  'fabric.editor.configPanel.formType.removeField': 'Удалить поле',
  'fabric.editor.configPanel.help': 'Нужна помощь?',
  'fabric.editor.configPanel.invalid': 'Недопустимое поле',
  'fabric.editor.configPanel.required': 'Обязательное поле',
  'fabric.editor.configPanel.submit': 'Отправить',
  'fabric.editor.copiedToClipboard': 'Скопировано!',
  'fabric.editor.copyToClipboard': 'Скопировать',
  'fabric.editor.cornerControl': 'Выделить таблицу',
  'fabric.editor.createComment': 'Комментировать',
  'fabric.editor.createCommentDisabled':
    'Можно комментировать только текст, заголовки, эмодзи, даты, упоминания, ссылки и статусы.',
  'fabric.editor.createCommentInvalid': 'Можно комментировать только текст и заголовки',
  'fabric.editor.createCommentOnInlineNodeSpotlight.action': 'Понятно',
  'fabric.editor.createCommentOnInlineNodeSpotlight.body':
    'Теперь вы можете оставлять комментарии к встроенным элементам, таким как ссылки, даты, статусы и упоминания.',
  'fabric.editor.customPanel': 'Пользовательская панель',
  'fabric.editor.customPanel.description': 'Добавьте примечание с эмодзи и цветным фоном',
  'fabric.editor.datasource.assetsObjects.description':
    'Вставка объектов из Активов в Jira Service Management с помощью поиска и фильтрации',
  'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'Активы',
  'fabric.editor.datasource.confluenceSearch': 'Вставка списка Confluence',
  'fabric.editor.datasource.confluenceSearch.description':
    'Вставка списка результатов поиска из Confluence с использованием возможностей расширенного поиска, фильтрации и настройки.',
  'fabric.editor.datasource.jiraIssue': 'Задачи Jira',
  'fabric.editor.datasource.jiraIssue.description':
    'Вставка задач Jira из Jira Cloud с помощью расширенного поиска, фильтрации и настройки.',
  'fabric.editor.datasource.jiraIssue.description.issue-term-refresh':
    'Вставляйте задачи Jira из Jira Cloud с помощью расширенного поиска, фильтрации и настройки.',
  'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Задачи Jira',
  'fabric.editor.datasourceAppearanceTitle': 'Список',
  'fabric.editor.datasourceTitle': 'Изменить поисковый запрос',
  'fabric.editor.date': 'Дата',
  'fabric.editor.date.description': 'Добавление даты из календаря',
  'fabric.editor.datePickerOpenedAlert':
    'Открылось всплывающее окно реактора даты. Для перехода к всплывающему окну нажмите клавишу табуляции',
  'fabric.editor.decision': 'Решение',
  'fabric.editor.decision.description': 'Записывайте решения для удобного отслеживания',
  'fabric.editor.decisionPlaceholder': 'Добавить решение…',
  'fabric.editor.decreaseSize': 'Уменьшить размер таблицы или медиа',
  'fabric.editor.defaultAltText': 'Документ',
  'fabric.editor.delete': 'Удалить',
  'fabric.editor.description': 'Описание',
  'fabric.editor.displayBlock': 'Отобразить карточку',
  'fabric.editor.displayEmbed': 'Отобразить как встроенный объект',
  'fabric.editor.displayInline': 'Отобразить внутри строки',
  'fabric.editor.displayLink': 'Отобразить в виде текста',
  'fabric.editor.displayOptionUnavailableInParentNode': 'Этот параметр отображения недоступен внутри узла {node}',
  'fabric.editor.displayText': 'Текст для отображения',
  'fabric.editor.distributeColumns': 'Распределить столбцы',
  'fabric.editor.dropPlaceholderLabel': 'Документ',
  'fabric.editor.ecombedDescription': 'Интерактивный предварительный просмотр ссылки',
  'fabric.editor.edit': 'Изменить',
  'fabric.editor.edit.datasource': 'Изменить поисковый запрос',
  'fabric.editor.edit.searchInput': 'Добавить ссылку',
  'fabric.editor.editAccessTitle': 'Вам нужен доступ для редактирования',
  'fabric.editor.editAltText': 'Изменить альтернативный текст',
  'fabric.editor.editDatasourceStandalone': 'Изменить',
  'fabric.editor.editDatasourceStandaloneTooltip': 'Изменить поисковый запрос',
  'fabric.editor.editDateText': 'Редактирование даты',
  'fabric.editor.editDropdownEditDatasourceTitle': 'Изменить поисковый запрос',
  'fabric.editor.editDropdownEditLinkTitle': 'Изменить ссылку',
  'fabric.editor.editDropdownExpandIconLabel': 'Развернуть выпадающее меню',
  'fabric.editor.editDropdownTriggerTitle': 'Изменить',
  'fabric.editor.editLink': 'Изменить ссылку',
  'fabric.editor.editMode.inviteToEditButton.title': 'Разрешить редактировать',
  'fabric.editor.editStatusColor': 'Редактировать цвет статуса',
  'fabric.editor.editStatusText': 'Редактировать статус',
  'fabric.editor.editableContentLabel': 'Контент можно редактировать',
  'fabric.editor.editorHelp': 'Справка по редактору',
  'fabric.editor.editors': 'Редакторы',
  'fabric.editor.elementBrowser.help': 'Справка',
  'fabric.editor.elementInsertSidePanel.title': 'Вставить',
  'fabric.editor.elementbrowser.categorylist.category-admin': 'Администрирование',
  'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
  'fabric.editor.elementbrowser.categorylist.category-all': 'Все',
  'fabric.editor.elementbrowser.categorylist.category-communication': 'Коммуникация',
  'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Содержимое Confluence',
  'fabric.editor.elementbrowser.categorylist.category-development': 'Разработка',
  'fabric.editor.elementbrowser.categorylist.category-external-content': 'Внешнее содержимое',
  'fabric.editor.elementbrowser.categorylist.category-formatting': 'Форматирование',
  'fabric.editor.elementbrowser.categorylist.category-media': 'Медиа',
  'fabric.editor.elementbrowser.categorylist.category-navigation': 'Навигация',
  'fabric.editor.elementbrowser.categorylist.category-reporting': 'Отчеты',
  'fabric.editor.elementbrowser.categorylist.category-visuals': 'Схемы и изображения',
  'fabric.editor.elementbrowser.search.empty-state.heading': 'По вашему запросу ничего не найдено',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading':
    'Попробуйте изменить запрос или узнайте о новых приложениях для продуктов Atlassian.',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': 'Ознакомиться с Atlassian Marketplace',
  'fabric.editor.elementbrowser.searchbar.assistive.text.default':
    '{count, plural, =0 {По вашему запросу ничего не найдено.} one {По умолчанию доступен {count} вариант.} few {По умолчанию доступно {count} варианта.} many {По умолчанию доступно {count} вариантов.} other {По умолчанию доступно {count} варианта.}}',
  'fabric.editor.elementbrowser.searchbar.assistive.text.result':
    '{count, plural, =0 {По вашему запросу ничего не найдено.} one {Для введенного текста доступно {count} предложение.} few {Для введенного текста доступно {count} предложения.} many {Для введенного текста доступно {count} предложений.} other {Для введенного текста доступно {count} предложения.}}',
  'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Ввод',
  'fabric.editor.elementbrowser.searchbar.placeholder': 'Поиск',
  'fabric.editor.elementbrowser.sidebar.heading': 'Обзор',
  'fabric.editor.embedTitle': 'Внедренный объект',
  'fabric.editor.emoji': 'Эмодзи',
  'fabric.editor.emoji.description': 'Делитесь идеями 🎉 и выражайте чувства 😄 с помощью эмодзи',
  'fabric.editor.emptyLink': 'Введите ссылку.',
  'fabric.editor.emptySearchResults': 'Ничего не найдено.',
  'fabric.editor.emptySearchResultsSuggestion': 'Нажмите «{buttonName}» для просмотра вставок.',
  'fabric.editor.epic': 'Эпик',
  'fabric.editor.error': 'Ошибка',
  'fabric.editor.errorPanel': 'Панель ошибок',
  'fabric.editor.errorPanel.description': 'Выделить ошибки цветом',
  'fabric.editor.expand': 'Разворачивание',
  'fabric.editor.expand.description': 'Вставить элемент разворачивания',
  'fabric.editor.expandAriaLabel': 'Укажите название для элемента развертывания',
  'fabric.editor.expandDefaultTitle': 'Нажмите здесь, чтобы развернуть…',
  'fabric.editor.expandNode': 'Разверните содержимое',
  'fabric.editor.expandPlaceholder': 'Укажите название для развернутого содержимого…',
  'fabric.editor.extension.confirmDeleteLinkedModalMessage':
    'При удалении элемента {nodeName} нарушится работа всего, что с ним связано.',
  'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': 'Удаление',
  'fabric.editor.extension.confirmDeleteLinkedModalOKButton': 'Удалить',
  'fabric.editor.extension.deleteElementTitle': 'Удаление элемента',
  'fabric.editor.extension.sourceNoTitledName': 'этого элемента',
  'fabric.editor.extensions.config-panel.save-indicator': 'Любые изменения всегда сохраняются автоматически',
  'fabric.editor.externalExtensionsHeading': 'Приложения',
  'fabric.editor.externalMediaFile': 'Внешний медиафайл',
  'fabric.editor.failed_to_upload': 'Ошибка загрузки',
  'fabric.editor.feedbackDialog': 'Оставить отзыв',
  'fabric.editor.feedbackDialog.description': 'Поделитесь впечатлениями о новом редакторе',
  'fabric.editor.find': 'Найти',
  'fabric.editor.findNext': 'Найти далее',
  'fabric.editor.findPrevious': 'Найти ранее',
  'fabric.editor.findReplaceToolbarButton': 'Найти и заменить',
  'fabric.editor.fiveColumns': 'Макет с 5 колонками',
  'fabric.editor.floatingToolbar.confirmModalCancel': 'Отмена',
  'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': 'Также удалить подключенные элементы',
  'fabric.editor.floatingToolbar.confirmModalConnectedUnit':
    '{amount, plural, =0 {{name}} one {{name} (и еще 1 подключенный элемент)} few {{name} (и еще {amount,number} подключенных элемента)} many {{name} (и еще {amount,number} подключенных элементов)} other {{name} (и еще {amount,number} подключенного элемента)}}',
  'fabric.editor.floatingToolbar.confirmModalHeading': 'Вы уверены?',
  'fabric.editor.floatingToolbar.confirmModalOK': 'ОК',
  'fabric.editor.floatingToolbar.floatingToolbarAnnouncer':
    'Открыты элементы управления на перемещаемой панели инструментов',
  'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': 'Перемещаемая панель инструментов',
  'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'Варианты компоновки',
  'fabric.editor.floatingToolbar.scrollLeft': 'Прокрутить влево',
  'fabric.editor.floatingToolbar.scrollRight': 'Прокрутить вправо',
  'fabric.editor.focusTableResizeHandle': 'Маркер для изменения размера активной таблицы',
  'fabric.editor.fourColumns': 'Макет с 4 колонками',
  'fabric.editor.headerColumn': 'Столбец заголовков',
  'fabric.editor.headerRow': 'Строка заголовков',
  'fabric.editor.heading1': 'Заголовок 1',
  'fabric.editor.heading1Description': 'Для заголовка верхнего уровня',
  'fabric.editor.heading2': 'Заголовок 2',
  'fabric.editor.heading2Description': 'Для подзаголовков',
  'fabric.editor.heading3': 'Заголовок 3',
  'fabric.editor.heading3Description': 'Для подразделов и групповых заголовков',
  'fabric.editor.heading4': 'Заголовок 4',
  'fabric.editor.heading4Description': 'Для заголовков с глубокой иерархией',
  'fabric.editor.heading5': 'Заголовок 5',
  'fabric.editor.heading5Description': 'Для группировки элементов списка',
  'fabric.editor.heading6': 'Заголовок 6',
  'fabric.editor.heading6Description': 'Для заголовков нижнего уровня',
  'fabric.editor.headingLink.ascOrderLabel': 'Сортировать столбцы (Я–А)',
  'fabric.editor.headingLink.descOrderLabel': 'Очистить сортировку',
  'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'Блог',
  'fabric.editor.headingLink.hyperlinkIconBugLabel': 'Баг',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel': 'Задача',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': 'Задача',
  'fabric.editor.headingLink.hyperlinkIconPageLabel': 'Страница',
  'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'История',
  'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'Задание',
  'fabric.editor.headingLink.invalidLabel': '⚠️ Невозможно отсортировать таблицу с объединением ячеек',
  'fabric.editor.headingLink.noOrderLabel': 'Сортировать столбцы (А–Я)',
  'fabric.editor.help': 'Справка',
  'fabric.editor.help.description': 'Все сочетания клавиш и параметры разметки',
  'fabric.editor.helpDialogTips': 'Это окно можно быстро открыть в любое время нажатием {keyMap}',
  'fabric.editor.highlight': 'Цвет выделения',
  'fabric.editor.highlightColor': 'Переключить цветовую палитру подсветки',
  'fabric.editor.highlightFloatingToolbar': 'Выделить',
  'fabric.editor.horizontalRule': 'Разделитель',
  'fabric.editor.horizontalRule.description': 'Разделение содержимого горизонтальной линией',
  'fabric.editor.hyperlink.linkVisibleLabel': 'Вставить или искать ссылку',
  'fabric.editor.hyperlink.searchLinkAriaDescription': 'Предложения будут появляться по мере ввода текста в поле',
  'fabric.editor.hyperlink.searchLinkResults':
    '{count, plural, =0 {нет результатов} one {найден {count,number} результат} few {найдено {count,number} результата} many {найдено {count,number} результатов} other {найдено {count,number} результата}}',
  'fabric.editor.hyperlink.textVisibleLabel': 'Текст для отображения (необязательно)',
  'fabric.editor.hyperlinkToolbarPlaceholder': 'Вставить или искать ссылку',
  'fabric.editor.image': 'Изображение',
  'fabric.editor.image.fullWidthLabel': 'Полная ширина',
  'fabric.editor.imageBorderBold': 'Широкая',
  'fabric.editor.imageBorderColor': 'Цвет',
  'fabric.editor.imageBorderColor.dropdownAriaLabel': 'Раскрывающийся список «Цвет» в параметрах границы изображения',
  'fabric.editor.imageBorderMedium': 'Средняя',
  'fabric.editor.imageBorderOptions': 'Параметры рамки',
  'fabric.editor.imageBorderSize': 'Размер',
  'fabric.editor.imageBorderSize.dropdownAriaLabel': 'Раскрывающийся список «Размер» в параметрах границы изображения',
  'fabric.editor.imageBorderSubtle': 'Узкая',
  'fabric.editor.improvement': 'Улучшение',
  'fabric.editor.increaseSize': 'Увеличить размер таблицы или медиа',
  'fabric.editor.indent': 'Сделать отступ',
  'fabric.editor.info': 'Информация',
  'fabric.editor.infoPanel': 'Информационная панель',
  'fabric.editor.infoPanel.description': 'Выделение информации цветом',
  'fabric.editor.inlineConfigureLink': 'Настроить ссылку',
  'fabric.editor.inlineDescription': 'Отображение ссылки в виде встроенного текста',
  'fabric.editor.inlineGoToLink': 'Перейти по ссылке',
  'fabric.editor.inlineOverlay': 'Настроить',
  'fabric.editor.inlineTitle': 'Встроенный текст',
  'fabric.editor.inputQueryAssistiveTxt':
    'Если доступны результаты автозаполнения, используйте клавиши со стрелками вверх и вниз для просмотра и клавишу Enter для выбора. Если у вас сенсорное устройство, используйте для просмотра касание и смахивание.',
  'fabric.editor.insertColumn': 'Вставить столбец справа',
  'fabric.editor.insertColumnDrag': 'Вставить столбец',
  'fabric.editor.insertMenu': 'Вставить элементы',
  'fabric.editor.insertRightRail.close': 'Закрыть',
  'fabric.editor.insertRightRail.title': 'Вставить',
  'fabric.editor.insertRow': 'Вставить строку ниже',
  'fabric.editor.insertRowDrag': 'Вставить строку',
  'fabric.editor.insertTableColumn': 'Вставить столбец таблицы',
  'fabric.editor.insertTableRow': 'Вставить строку таблицы',
  'fabric.editor.invalidDateError': 'Введите действительную дату',
  'fabric.editor.invalidLink': 'Введите действительную ссылку.',
  'fabric.editor.inviteItem.title':
    '{userRole, select, admin {Пригласить коллегу начать работу с {productName}} trusted {Пригласить коллегу начать работу с {productName}} other {Добавить коллегу для работы с {productName}}}',
  'fabric.editor.italic': 'Курсив',
  'fabric.editor.keyboardShortcuts': 'Сочетания клавиш',
  'fabric.editor.layout.columnOption':
    '{count, plural, one {Колонка} few {{count} колонки} many {{count} колонок} other {{count} колонки}}',
  'fabric.editor.layout.controls.placeholder': 'Введите «/» для вставки',
  'fabric.editor.layout.placeholder': 'Добавить контент',
  'fabric.editor.layout.resizeLayout': 'Изменить размер макета',
  'fabric.editor.layoutFixedWidth': 'По центру',
  'fabric.editor.layoutFullWidth': 'В полную ширину',
  'fabric.editor.layoutStateFixedWidth': 'По центру',
  'fabric.editor.layoutStateFullWidth': 'Полная ширина',
  'fabric.editor.layoutStateWide': 'Широкий',
  'fabric.editor.layoutWide': 'Шире обычного',
  'fabric.editor.leftSidebar': 'Макет с левой боковой панелью',
  'fabric.editor.link': 'Ссылка',
  'fabric.editor.link.description': 'Вставить ссылку',
  'fabric.editor.linkAddress': 'Добавить адрес ссылки',
  'fabric.editor.linkPlaceholder': 'Вставить ссылку',
  'fabric.editor.lists': 'Списки',
  'fabric.editor.listsFormat': 'Форматирование списка',
  'fabric.editor.lockColumns': 'Фиксированная ширина столбцов',
  'fabric.editor.longEmptyNodePlaceholderText': 'Чтобы вставить элементы, введите «/»',
  'fabric.editor.markdown': 'Markdown',
  'fabric.editor.matchCase': 'С учетом регистра',
  'fabric.editor.media.DefaultMediaWidthDecreased':
    '{newMediaWidth, plural, one {Ширина объекта мультимедиа уменьшена до {newMediaWidth,number} пикселя.} few {Ширина объекта мультимедиа уменьшена до {newMediaWidth,number} пикселей.} many {Ширина объекта мультимедиа уменьшена до {newMediaWidth,number} пикселей.} other {Ширина объекта мультимедиа уменьшена до {newMediaWidth,number} пикселя.}}',
  'fabric.editor.media.DefaultMediaWidthIncreased':
    '{newMediaWidth, plural, one {Ширина объекта мультимедиа увеличена до {newMediaWidth,number} пикселя.} few {Ширина объекта мультимедиа увеличена до {newMediaWidth,number} пикселей.} many {Ширина объекта мультимедиа увеличена до {newMediaWidth,number} пикселей.} other {Ширина объекта мультимедиа увеличена до {newMediaWidth,number} пикселя.}}',
  'fabric.editor.media.MediaWidthIsMin': 'Размер медиа уменьшен до минимума',
  'fabric.editor.media.insert.cancel': 'Отмена',
  'fabric.editor.media.insert.fileTabTitle': 'Файл',
  'fabric.editor.media.insert.fromUrlErrorMessage':
    'Невозможно добавить изображение по этой ссылке. Загрузите изображение, а затем перетащите его на страницу.',
  'fabric.editor.media.insert.fromUrlWarning':
    'Это изображение может быть скрыто от других пользователей из-за ограничений источника. Вместо этого попробуйте загрузить файл.',
  'fabric.editor.media.insert.insert': 'Вставить',
  'fabric.editor.media.insert.invalidUrlErrorMessage': 'Недействительная ссылка',
  'fabric.editor.media.insert.linkTabTitle': 'Ссылка',
  'fabric.editor.media.insert.loadPreview': 'Загрузить предпросмотр',
  'fabric.editor.media.insert.localFileErrorMessage': 'Не удалось загрузить файл.',
  'fabric.editor.media.insert.localFileNetworkErrorMessage':
    'Ошибка загрузки файла. Проверьте путь к файлу или подключение к сети.',
  'fabric.editor.media.insert.mediaAlt': 'Предпросмотр загруженного изображения или видеофайла',
  'fabric.editor.media.insert.mediaPickerPopupAriaLabel': 'Средство выбора медиафайлов',
  'fabric.editor.media.insert.pasteLinkToUpload': 'Вставьте ссылку, чтобы загрузить файл',
  'fabric.editor.media.insert.upload': 'Загрузить',
  'fabric.editor.media.pixelEntry.MediaWidthIsMax': 'Размер медиа увеличен до максимума',
  'fabric.editor.media.pixelEntry.ResizeOption': 'Изменить размер',
  'fabric.editor.media.pixelEntry.closePixelEntry': 'Закрыть',
  'fabric.editor.media.pixelEntry.inputHeightAriaLabel': 'ввод высоты',
  'fabric.editor.media.pixelEntry.inputHeightTooltip': 'Высота',
  'fabric.editor.media.pixelEntry.inputWidthAriaLabel': 'Максимальная ширина {maxWidth} пикс.',
  'fabric.editor.media.pixelEntry.inputWidthLabel': 'Ширина',
  'fabric.editor.media.pixelEntry.inputWidthTooltip': 'Максимальная ширина {maxWidth} пикс.',
  'fabric.editor.media.pixelEntry.migrationButtonText': 'Преобразовать в пиксели',
  'fabric.editor.media.pixelEntry.migrationButtonTooltip':
    'Перейти от процентного соотношения к фиксированным размерам в пикселях',
  'fabric.editor.media.pixelEntry.submitButtonText': 'Отправить',
  'fabric.editor.media.pixelEntry.validationFailedMessage': 'Не удалось проверить ширину',
  'fabric.editor.mediaAddLink': 'Добавить ссылку',
  'fabric.editor.mediaFiles': 'Изображение, видео или файл',
  'fabric.editor.mediaFiles.description': 'Добавление на страницу изображений и других файлов',
  'fabric.editor.mediaGroupDeleteLabel': 'Удалить',
  'fabric.editor.media_change_mediainline_caption_warn': 'Встроенное (подпись будет удалена)',
  'fabric.editor.media_change_mediainline_default': 'Встроенный текст',
  'fabric.editor.media_change_mediasingle': 'Исходный размер',
  'fabric.editor.mention': 'Упоминание',
  'fabric.editor.mention.description': 'Упомяните коллегу — он получит уведомление',
  'fabric.editor.mentionNode.label': 'Упомянут пользователь',
  'fabric.editor.mentionsAddLabel': 'добавить-значок',
  'fabric.editor.mentionsIconLabel': 'Упоминание',
  'fabric.editor.mergeCells': 'Объединить ячейки',
  'fabric.editor.moreFormatting': 'Расширенные параметры форматирования',
  'fabric.editor.moveColumnLeft':
    '{0, plural, one {Сдвинуть столбец влево} few {Сдвинуть столбцы влево} many {Сдвинуть столбцы влево} other {Сдвинуть столбцы влево}}',
  'fabric.editor.moveColumnRight':
    '{0, plural, one {Сдвинуть столбец вправо} few {Сдвинуть столбцы вправо} many {Сдвинуть столбцы вправо} other {Сдвинуть столбцы вправо}}',
  'fabric.editor.moveDownDown':
    '{0, plural, one {Сдвинуть строку вниз} few {Сдвинуть строки вниз} many {Сдвинуть строки вниз} other {Сдвинуть строки вниз}}',
  'fabric.editor.moveRowUp':
    '{0, plural, one {Сдвинуть строку вверх} few {Сдвинуть строки вверх} many {Сдвинуть строки вверх} other {Сдвинуть строки вверх}}',
  'fabric.editor.navigate.toolbar.editor': 'Перейти на панель инструментов редактора',
  'fabric.editor.navigate.toolbar.floating': 'Перейти на перемещаемую панель инструментов',
  'fabric.editor.noResultsFound': 'Ничего не найдено',
  'fabric.editor.noSearchResults': 'Ничего не найдено',
  'fabric.editor.normal': 'Обычный текст',
  'fabric.editor.note': 'Примечание',
  'fabric.editor.notePanel': 'Панель примечаний',
  'fabric.editor.notePanel.description': 'Добавить цветную заметку',
  'fabric.editor.numberedColumn': 'Столбец с нумерацией',
  'fabric.editor.off': '{formattingType} выкл.',
  'fabric.editor.offlineErrorFallbackDescription': 'Попробуйте перезагрузить страницу.',
  'fabric.editor.offlineErrorFallbackHeading': 'Произошла ошибка.',
  'fabric.editor.on': '{formattingType} вкл.',
  'fabric.editor.openCellOptions': 'Открыть параметры ячейки',
  'fabric.editor.openLink': 'Открыть ссылку на новой вкладке',
  'fabric.editor.orderedList': 'Нумерованный список',
  'fabric.editor.orderedList.description': 'Создание нумерованного списка',
  'fabric.editor.other': 'Прочее…',
  'fabric.editor.outdent': 'Убрать отступ',
  'fabric.editor.overflowMenuViewMore': 'Развернуть',
  'fabric.editor.pageActionsLabel': 'Действия со страницей',
  'fabric.editor.panel': 'Панель',
  'fabric.editor.panel.backgroundColor': 'Цвет фона',
  'fabric.editor.panel.custom': 'Свой вариант',
  'fabric.editor.panel.emoji': 'Добавить эмодзи',
  'fabric.editor.panel.panelsGroup': 'Типы панелей',
  'fabric.editor.pasteOptions': 'Параметры вставки',
  'fabric.editor.pastePlainText': 'Вставить обычный текст',
  'fabric.editor.placeholderAltText': 'Альтернативный текст для описания изображения',
  'fabric.editor.placeholderText': 'Замещающий текст',
  'fabric.editor.placeholderText.description': 'Вставить текстовый заполнитель на страницу',
  'fabric.editor.placeholderTextPlaceholder': 'Добавить замещающий текст',
  'fabric.editor.plainText': 'Использовать неформатированный текст',
  'fabric.editor.preferencesLink': 'Настройки ссылок',
  'fabric.editor.quickInsert': 'Быстрая вставка',
  'fabric.editor.recordLoomShortTitle': 'Записать',
  'fabric.editor.recordVideo': 'Записать видео Loom',
  'fabric.editor.recordVideo.description': 'Запишите видео с экрана и поделитесь своими мыслями',
  'fabric.editor.redo': 'Вернуть',
  'fabric.editor.remove': 'Удалить',
  'fabric.editor.removeColumns':
    '{0, plural, one {Удалить столбец} few {Удалить столбцы} many {Удалить столбцы} other {Удалить столбцы}}',
  'fabric.editor.removeEmoji': 'Удаление эмодзи',
  'fabric.editor.removeImageBorder': 'Удалить рамку',
  'fabric.editor.removeRows':
    '{0, plural, one {Удалить строку} few {Удалить строки} many {Удалить строки} other {Удалить строки}}',
  'fabric.editor.replace': 'Заменить',
  'fabric.editor.replaceAll': 'Заменить все',
  'fabric.editor.replaceSuccess':
    '{numberOfMatches, plural, one {Выполнена {numberOfMatches,number} замена} few {Выполнено {numberOfMatches,number} замены} many {Выполнено {numberOfMatches,number} замен} other {Выполнено {numberOfMatches,number} замены}}',
  'fabric.editor.replaceWith': 'Заменить на',
  'fabric.editor.requestToEdit': 'Запрос на редактирование',
  'fabric.editor.requestToEditDescription': 'Когда вы запросите доступ, владелец страницы получит уведомление.',
  'fabric.editor.requestToEditDismiss': 'Закрыть',
  'fabric.editor.resultsCount': '{selectedMatchPosition} из {totalResultsCount}',
  'fabric.editor.richText': 'Использовать форматированный текст',
  'fabric.editor.rightSidebar': 'Макет с правой боковой панелью',
  'fabric.editor.rowControl': 'Выделить строку',
  'fabric.editor.rowDragHandle': 'Параметры строки',
  'fabric.editor.rowMovedDown': 'Строка перемещена вниз на позицию {index} из {total}',
  'fabric.editor.rowMovedUp': 'Строка перемещена вверх на позицию {index} из {total}',
  'fabric.editor.rowSelected': 'Выбрана строка {index} из {total}',
  'fabric.editor.rowsAreInserted':
    '{count, plural, one {Вставлена {count} строка} few {Вставлено {count} строки} many {Вставлено {count} строк} other {Вставлено {count} строки}}',
  'fabric.editor.rowsAreRemoved':
    '{count, plural, one {Удалена {count} строка} few {Удалено {count} строки} many {Удалено {count} строк} other {Удалено {count} строки}}',
  'fabric.editor.saveButton': 'Сохранить',
  'fabric.editor.searchResults':
    '{itemsLength, plural, one {{itemsLength,number} результат поиска. Используйте клавиши со стрелками вверх и вниз для навигации по параметрам и клавишу Enter для выбора параметра.} few {{itemsLength,number} результата поиска. Используйте клавиши со стрелками вверх и вниз для навигации по параметрам и клавишу Enter для выбора параметра.} many {{itemsLength,number} результатов поиска. Используйте клавиши со стрелками вверх и вниз для навигации по параметрам и клавишу Enter для выбора параметра.} other {{itemsLength,number} результата поиска. Используйте клавиши со стрелками вверх и вниз для навигации по параметрам и клавишу Enter для выбора параметра.}}',
  'fabric.editor.selectColumnResize': 'Выбрать изменение размера столбца',
  'fabric.editor.selectLanguage': 'Выберите язык',
  'fabric.editor.selectTableColumn': 'Выбрать столбец таблицы',
  'fabric.editor.selectTableRow': 'Выбрать строку таблицы',
  'fabric.editor.selectionExtensionDropdownButtonLabel': 'Выбрать приложение',
  'fabric.editor.settingsLinks': 'Перейти к настройкам ссылок',
  'fabric.editor.shortEmptyNodePlaceholderText': 'Введите «/» для вставки',
  'fabric.editor.shortcut': 'Текстовый ярлык',
  'fabric.editor.single': 'Макет в один столбец',
  'fabric.editor.singleColumns': 'Макет с 1 колонкой',
  'fabric.editor.sortColumnASC': 'Сортировать столбцы (А–Я)',
  'fabric.editor.sortColumnDESC': 'Сортировать столбцы (Я–А)',
  'fabric.editor.sortColumnDecreasing': 'Сортировать по убыванию',
  'fabric.editor.sortColumnIncreasing': 'Сортировать по возрастанию',
  'fabric.editor.splitCell': 'Разделить ячейки',
  'fabric.editor.status': 'Статус',
  'fabric.editor.status.description': 'Добавление пользовательской метки статуса',
  'fabric.editor.statusEditorLabel': 'Редактор статуса',
  'fabric.editor.statusPickerOpenedAlert':
    'Открылось всплывающее окно редактора статуса. Для перехода к всплывающему окну нажмите клавишу табуляции.',
  'fabric.editor.statusPlaceholder': 'Задать статус',
  'fabric.editor.story': 'История',
  'fabric.editor.strike': 'Зачеркнутый',
  'fabric.editor.subTask': 'Подзадача',
  'fabric.editor.subscript': 'Подстрочный',
  'fabric.editor.subscript.off.superscript.on': 'Нижний индекс выкл., верхний индекс вкл.',
  'fabric.editor.success': 'Готово',
  'fabric.editor.successPanel': 'Панель «Готово»',
  'fabric.editor.successPanel.description': 'Добавить цветные подсказки',
  'fabric.editor.superscript': 'Надстрочный',
  'fabric.editor.superscript.off.subscript.on': 'Верхний индекс выкл., нижний индекс вкл.',
  'fabric.editor.supportAltText':
    'Альтернативный текст предназначен для слабовидящих и незрячих людей, которые пользуются функцией озвучивания текста на экране.',
  'fabric.editor.table': 'Таблица',
  'fabric.editor.table.description': 'Вставка таблицы',
  'fabric.editor.tableAlignmentOptions': 'Варианты выравнивания',
  'fabric.editor.tableFullWidthLabel': 'Полная ширина',
  'fabric.editor.tableHeader.sorting.asc': 'Применяется сортировка по возрастанию',
  'fabric.editor.tableHeader.sorting.default': 'Сортировать столбец',
  'fabric.editor.tableHeader.sorting.desc': 'Применяется сортировка по убыванию',
  'fabric.editor.tableHeader.sorting.invalid': 'Невозможно отсортировать таблицу с объединенными ячейками',
  'fabric.editor.tableHeader.sorting.no': 'Сортировка столбца не применяется',
  'fabric.editor.tableOptions': 'Параметры таблицы',
  'fabric.editor.tableResizeDecreaseScreenReaderInformation':
    '{newWidth, plural, one {Ширина таблицы уменьшена до {newWidth,number} пикселя.} few {Ширина таблицы уменьшена до {newWidth,number} пикселей.} many {Ширина таблицы уменьшена до {newWidth,number} пикселей.} other {Ширина таблицы уменьшена до {newWidth,number} пикселя.}}',
  'fabric.editor.tableResizeIncreaseScreenReaderInformation':
    '{newWidth, plural, one {Ширина таблицы увеличена до {newWidth,number} пикселя.} few {Ширина таблицы увеличена до {newWidth,number} пикселей.} many {Ширина таблицы увеличена до {newWidth,number} пикселей.} other {Ширина таблицы увеличена до {newWidth,number} пикселя.}}',
  'fabric.editor.tableSelector': 'Размер таблицы',
  'fabric.editor.tableSelector.description':
    'Добавьте таблицу с помощью всплывающего окна, чтобы выбрать пользовательский размер',
  'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} x {numberOfRows}',
  'fabric.editor.tableSizeSelectorPopup': 'Селектор размера таблицы',
  'fabric.editor.tables.adjustColumn': 'Скорректировать ширину столбца',
  'fabric.editor.tables.columnResizeLast': 'Размер этого столбца можно изменить только слева.',
  'fabric.editor.tables.columnResizeOverflow':
    'Размер этого столбца можно изменить, только если у таблицы есть полоса прокрутки.',
  'fabric.editor.tables.columnWidth':
    '{width, plural, one {Ширина столбца теперь составляет {width} пиксель} few {Ширина столбца теперь составляет {width} пикселя} many {Ширина столбца теперь составляет {width} пикселей} other {Ширина столбца теперь составляет {width} пикселя}}',
  'fabric.editor.tables.confirmDeleteLinkedModalMessage':
    'При удалении элемента «{nodeName}» нарушится работа всего, что с ним связано.',
  'fabric.editor.tables.confirmDeleteLinkedModalOKButton': 'Удалить',
  'fabric.editor.tables.resizeStop': 'Прекращено изменение размера',
  'fabric.editor.tables.resizeTable': 'Изменить размер таблицы',
  'fabric.editor.tables.startedColumnResize': 'Начато изменение размера столбца',
  'fabric.editor.task': 'Задание',
  'fabric.editor.taskPlaceholder': 'Укажите задание и назначьте исполнителя с помощью значка «@».',
  'fabric.editor.text.formatting.off': 'Форматирование текста выкл.',
  'fabric.editor.textColor': 'Цвет текста: {selectedColorName}',
  'fabric.editor.textColorTooltip': 'Цвет текста',
  'fabric.editor.textFormat': 'Форматировать текст',
  'fabric.editor.textFormatting': 'Форматирование текста',
  'fabric.editor.textStyles': 'Стили текста: {blockTypeName}',
  'fabric.editor.textStylesTooltip': 'Стили текста',
  'fabric.editor.threeColumns': 'Макет с 3 колонками',
  'fabric.editor.threeColumnsWithLeftSidebars': 'Макет с тремя колонками и левой боковой панелью',
  'fabric.editor.threeColumnsWithRightSidebars': 'Макет с тремя колонками и правой боковой панелью',
  'fabric.editor.threeColumnsWithSidebars': 'Макет в три столбца с боковыми панелями',
  'fabric.editor.time.ago': 'тому назад',
  'fabric.editor.time.updated': 'Дата обновления',
  'fabric.editor.time.viewed': 'Дата просмотра',
  'fabric.editor.toolbarAppears': 'Панель инструментов появится',
  'fabric.editor.toolbarLabel': 'Редактор',
  'fabric.editor.toolbarMediaTitle': 'Добавить изображение, видео или файл',
  'fabric.editor.toolbarPositionFixedAtTop': 'Закрепить наверху',
  'fabric.editor.toolbarPositionInline': 'В тексте',
  'fabric.editor.tooltip.blockPanel': 'панель',
  'fabric.editor.tooltip.bulletList': 'список',
  'fabric.editor.tooltip.decisionList': 'список решений',
  'fabric.editor.tooltip.defaultBlockNode': 'узел блоков',
  'fabric.editor.tooltip.nestedExpand': 'узел развертывания вложенных элементов',
  'fabric.editor.tooltip.taskList': 'действие',
  'fabric.editor.turnInto': 'Превратить в',
  'fabric.editor.twoColumns': 'Макет с 2 колонками',
  'fabric.editor.typeAhead.popupLabel': 'Результаты автозаполнения',
  'fabric.editor.typeAhead.quickInsertInputLabel': 'Начните вводить текст для поиска или фильтрации сочетаний клавиш',
  'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': 'Поиск',
  'fabric.editor.typeAhead.quickInsertPopupLabel': 'Сочетания клавиш для вставки и форматирования',
  'fabric.editor.typeahead.emojiInputLabel': 'Начните вводить текст для поиска или фильтрации эмодзи',
  'fabric.editor.typeahead.emojiListItemLabel': 'Сочетание клавиш для эмодзи {name}: {shortcut}',
  'fabric.editor.typeahead.emojiPopupLabel': 'Сочетания клавиш для эмодзи',
  'fabric.editor.typeahead.mentionInputLabel':
    'Начните вводить текст для поиска пользователей, которых можно упомянуть',
  'fabric.editor.typeahead.mentionPopupLabel': 'Пользователи, которых можно упомянуть',
  'fabric.editor.typeahead.metionListItemLabel': 'Пользователь {name} @{shortName}',
  'fabric.editor.unableToLoadContent': 'Не удалось загрузить контент',
  'fabric.editor.unableToOpenLink': 'Не удалось открыть ссылку',
  'fabric.editor.underline': 'Подчеркнутый',
  'fabric.editor.undo': 'Отменить',
  'fabric.editor.unknown.label': 'Неизвестно',
  'fabric.editor.unlink': 'Удалить ссылку',
  'fabric.editor.unorderedList': 'Маркированный список',
  'fabric.editor.unorderedList.description': 'Создание неупорядоченного списка',
  'fabric.editor.unsupportedBlockContent': 'Этот редактор не поддерживает отображение такого контента',
  'fabric.editor.unsupportedContentTooltip':
    'Контент недоступен в этом редакторе, при редактировании и сохранении он останется неизменным',
  'fabric.editor.unsupportedInlineContent': 'Контент не поддерживается.',
  'fabric.editor.upDown':
    'Используйте клавиши со стрелками вверх и вниз в следующем поле ввода, чтобы изменить дату ниже',
  'fabric.editor.url': 'Отобразить URL-адрес',
  'fabric.editor.urlDescription': 'Отображение ссылки в виде URL-адреса',
  'fabric.editor.urlTitle': 'URL-адрес',
  'fabric.editor.useMarkdown': 'Использовать разметку',
  'fabric.editor.viewAndAddCommentsOnMedia': 'Просмотреть и добавить комментарии',
  'fabric.editor.viewCommentOnMedia': 'Просмотреть комментарии',
  'fabric.editor.viewMore': 'Развернуть',
  'fabric.editor.viewMoreAriaLabel': 'Просмотреть все элементы',
  'fabric.editor.visit': 'Открыть ссылку в новом окне',
  'fabric.editor.warning': 'Предупреждение',
  'fabric.editor.warningPanel': 'Панель с предупреждением',
  'fabric.editor.warningPanel.description': 'Добавить цветное предупреждение',
  'fabric.editor.wrapLeft': 'Заверстать влево',
  'fabric.editor.wrapRight': 'Заверстать вправо',
  'fabric.emoji.label': 'Эмодзи',
  'fabric.theme.blue': 'Синий',
  'fabric.theme.bold-blue': 'Ярко-синий',
  'fabric.theme.bold-gray': 'Ярко-серый',
  'fabric.theme.bold-green': 'Ярко-зеленый',
  'fabric.theme.bold-magenta': 'Ярко-пурпурный',
  'fabric.theme.bold-orange': 'Ярко-оранжевый',
  'fabric.theme.bold-purple': 'Ярко-фиолетовый',
  'fabric.theme.bold-red': 'Ярко-красный',
  'fabric.theme.bold-teal': 'Ярко-бирюзовый',
  'fabric.theme.bold-yellow': 'Ярко-желтый',
  'fabric.theme.bolder-blue': 'Более яркий синий',
  'fabric.theme.bolder-gray': 'Более яркий серый',
  'fabric.theme.bolder-green': 'Более яркий зеленый',
  'fabric.theme.bolder-magenta': 'Более яркий пурпурный',
  'fabric.theme.bolder-orange': 'Более яркий оранжевый',
  'fabric.theme.bolder-purple': 'Более яркий фиолетовый',
  'fabric.theme.bolder-red': 'Более яркий красный',
  'fabric.theme.bolder-teal': 'Более яркий бирюзовый',
  'fabric.theme.bolder-yellow': 'Более яркий желтый',
  'fabric.theme.dark-blue': 'Темно-синий',
  'fabric.theme.dark-gray': 'Темно-серый',
  'fabric.theme.dark-green': 'Темно-зеленый',
  'fabric.theme.dark-purple': 'Темно-фиолетовый',
  'fabric.theme.dark-red': 'Темно-красный',
  'fabric.theme.dark-teal': 'Темно-бирюзовый',
  'fabric.theme.dark-yellow': 'Темно-желтый',
  'fabric.theme.default': 'По умолчанию',
  'fabric.theme.gray': 'Серый',
  'fabric.theme.green': 'Зеленый',
  'fabric.theme.light-blue': 'Голубой',
  'fabric.theme.light-gray': 'Светло-серый',
  'fabric.theme.light-green': 'Светло-зеленый',
  'fabric.theme.light-purple': 'Светло-фиолетовый',
  'fabric.theme.light-red': 'Светло-красный',
  'fabric.theme.light-teal': 'Светло-бирюзовый',
  'fabric.theme.light-yellow': 'Светло-желтый',
  'fabric.theme.lime': 'Лаймовый',
  'fabric.theme.magenta': 'Пурпурный',
  'fabric.theme.no-color': 'Без выделения',
  'fabric.theme.orange': 'Оранжевый',
  'fabric.theme.purple': 'Фиолетовый',
  'fabric.theme.red': 'Красный',
  'fabric.theme.subtle-blue': 'Бледно-голубой',
  'fabric.theme.subtle-gray': 'Бледно-серый',
  'fabric.theme.subtle-green': 'Бледно-зеленый',
  'fabric.theme.subtle-magenta': 'Бледно-пурпурный',
  'fabric.theme.subtle-orange': 'Бледно-оранжевый',
  'fabric.theme.subtle-purple': 'Бледно-фиолетовый',
  'fabric.theme.subtle-red': 'Бледно-красный',
  'fabric.theme.subtle-teal': 'Бледно-бирюзовый',
  'fabric.theme.subtle-yellow': 'Бледно-желтый',
  'fabric.theme.teal': 'Бирюзовый',
  'fabric.theme.white': 'Белый',
  'fabric.theme.yellow': 'Желтый',
  'fabrid.editor.rowNumbers': 'Номера строк',
  'rovo.agents.dropdown.title': 'Агенты',
  'rovo.agents.dropdown.viewAgents.label': 'Показать всех агентов',
};
